import { AxiosInstance } from 'axios';
import { v4 } from 'uuid';

/**
 * Inject correlation id and requesting-app to requests
 */
export const addCorrelationIdToRequests = (client: AxiosInstance) => {
  client.interceptors.request.use(config => ({
    ...config,
    headers: {
      ...config.headers,
      'X-Manheim-Correlation-ID': v4().split('-')[0]
    }
  }));
};
